import {createStore } from 'redux';
import draftReducer from '../reducers/draftShoopReducers';


export default createStore(draftReducer);